import React from 'react';

import { Box } from '@material-ui/core';
import { useDrag } from 'react-dnd';
import { FiMenu } from 'react-icons/fi';

import { AppLink } from '@vyce/core/src/components';
import { FormTemplateDoc } from '@vyce/core/src/api/types';
import { buildFormUrlSegment } from '@vyce/core/src/utils';

interface Props {
  template: FormTemplateDoc;
  title?: string;
  dragType: string;
}

export const DraggableTemplateTitleCell: React.FC<Props> = ({ template, title, dragType }) => {
  const [{ isDragging }, dragRef] = useDrag(
    () => ({
      type: dragType,
      item: { template },
      collect: monitor => ({ isDragging: monitor.isDragging() }),
    }),
    [template, dragType]
  );

  const displayTitle = title || template.title || '';
  const to = `/forms/form-templates/${buildFormUrlSegment(displayTitle, template.id || '')}/edit`;

  return (
    <div ref={dragRef} style={{ cursor: 'grab', width: '100%' }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        style={{ opacity: isDragging ? 0.5 : 1 }}
      >
        <Box display="flex" alignItems="center" gridGap={8} flexGrow={1} minWidth={0}>
          <FiMenu size={14} color="#8F95A3" style={{ flexShrink: 0 }} />
          <Box
            flexGrow={1}
            minWidth={0}
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: 1.4,
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            <AppLink to={to}>{displayTitle}</AppLink>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
